import AdvertisingImportMasterPage from './AdvertisingImportMasterPage';

export default AdvertisingImportMasterPage;
